// Third party
import { useTranslation } from 'react-i18next';

// Hooks
import { BaseDialog, TDialogAction } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../hooks/useAppStore';

// Redux-toolkit
import { getIsOpenDeleteTeamDialog, getSelectedTeam } from '../../../store/commissions/selectors';
import { useDeleteTeamAPI } from '../../../hooks/api/useCommissions';
import { commissionsActions } from '../../../store/commissions/slice';

const DeleteTeamCommission = () => {
  const { t } = useTranslation(['team', 'common']);
  const { mutate: deleteTeamMutate, isLoading } = useDeleteTeamAPI();
  const dispatch = useAppDispatch();
  const selectTeam = useAppSelector(getSelectedTeam);
  const isOpenDeleteTeamDialog = useAppSelector(getIsOpenDeleteTeamDialog);

  const deleteTeam = () => {
    deleteTeamMutate(selectTeam.id);
  };

  const handleCloseDialog = () => {
    dispatch(commissionsActions.setIsOpenDeleteTeamDialog(false));
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel', { ns: 'common' }),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleCloseDialog(),
    },
    {
      label: t('delete', { ns: 'common' }),
      color: 'primary',
      isLoading,
      onClick: () => deleteTeam(),
    },
  ];

  return (
    <BaseDialog
      dialogContent={t('areYouSureYouWantToDeleteTeam')}
      isOpenDialog={isOpenDeleteTeamDialog}
      dialogTitle={t('deleteTeam')}
      handleClose={handleCloseDialog}
      dialogActions={dialogActions}
    />
  );
};

export {
  DeleteTeamCommission,
};
